import { Contest } from '@/types/contest'
import { create } from 'zustand'
import { persist } from 'zustand/middleware'

interface BookmarkStore {
  bookmarks: Contest[]
  addBookmark: (contest: Contest) => void
  removeBookmark: (contestId: number) => void
  isBookmarked: (contestId: number) => boolean
  handleBookMarkClick: (contest: Contest) => void
}

export const useBookmarkStore = create<BookmarkStore>()(
  persist(
    (set, get) => ({
      bookmarks: [],
      addBookmark: (contest: Contest) => {
        set((state) => ({
          bookmarks: [...state.bookmarks, contest],
        }))
      },
      removeBookmark: (contestId: number) => {
        set((state) => ({
          bookmarks: state.bookmarks.filter(
            (contest) => contest.id !== contestId
          ),
        }))
      },
      isBookmarked: (contestId: number) =>
        get().bookmarks.some((contest) => contest.id === contestId),
      handleBookMarkClick: (contest: Contest) => {
        if (get().isBookmarked(contest.id)) {
          get().removeBookmark(contest.id)
        } else {
          get().addBookmark(contest)
        }
      },
    }),
    {
      name: 'bookmark-storage',
    }
  )
)
